export default {
  init(moduleEl) {
    const btnEl = moduleEl.querySelector('.js-load-more');
    const refWrapperEl = moduleEl.querySelector('.references-inner');

    btnEl.addEventListener('click', () => {
      window.smr_eventbus.emit('load_more_references');
      btnEl.classList.add('loading');
    });

    window.smr_eventbus.on('data loaded: replace_references', (data) => {
      setTimeout(() => {
        this.checkForMorePages(data, btnEl, refWrapperEl);
      }, 50);
    });

    window.smr_eventbus.on('data loaded: append_references', (data) => {
      setTimeout(() => {
        this.checkForMorePages(data, btnEl, refWrapperEl);
      }, 50);
    });
  },
  // enables/disables load more button depending on pagination possibility
  checkForMorePages(data, btnEl, refWrapperEl) {
    btnEl.classList.remove('loading');
    const itemsCount =
      refWrapperEl.querySelectorAll('.reference-teaser').length;

    if (data.meta.current_page >= data.meta.last_page && itemsCount % 9 !== 0) {
      btnEl.classList.add('d-none');
    } else {
      btnEl.classList.remove('d-none');
    }
  },
};
